export default __webpack_public_path__ + "static/media/13.8fa838e2.txt";